import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpClientHelperService } from "./http-client-helper.service";

@Injectable({
  providedIn: 'root'
})
export class ApiClientDashboardService {
  constructor(private httpClientHelper: HttpClientHelperService) { }

  private readonly controller = 'dashboard';

  generateDashboardUrl(): Observable<string> {
      return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetMainEmbedUrl`);
  }

  generateCMPDashboardUrl() {
    return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetCmpEmbedUrl`);
  }

  generateDSRAuditDashboardUrl(): Observable<string> {
    return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetDsrAuditLogEmbedUrl`);
  }

  generateAssessmentsDashboardUrl(): Observable<string> {
    return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetAssessmentsEmbedUrl`);
  }

  generateRiskEmbedDashboardEmbedUrl(): Observable<string> {
    return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetRiskEmbedUrl`);
  }

  generateAiGovDashboardUrl(): Observable<string> {
      return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetAIGovEmbeddedUrl`);
  }
  
  generateGovDashboardUrl(): Observable<string> {
      return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetGovernanceEmbeddedUrl`);
  }

  generateTPRMDashboardUrl(): Observable<string> {
      return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetTPRMEmbeddedUrl`);
  }

  generateDsrCaliforniaDropDashboardUrl(): Observable<string> {
      return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetDsrCaliforniaDropEmbedUrl`);
  }
}
